// Shared Firestore write hygiene helpers
// NOTE: This is a mechanical utility – it only strips undefined values so
// Firestore writes never include undefined, which Firestore does not support.

/**
 * Recursively removes properties whose value is strictly `undefined`.
 * - Preserves `null` as an intentional value
 * - Treats non-plain objects (e.g. Firestore sentinels, Timestamps) as leaf values
 */
export const sanitizeForFirestore = (value) => {
  if (value === undefined) {
    return undefined;
  }

  if (value === null || typeof value !== 'object') {
    return value;
  }

  // Treat non-plain objects (including Firestore FieldValue, Timestamp, etc.) as leaf values
  const proto = Object.getPrototypeOf(value);
  if (!Array.isArray(value) && proto !== Object.prototype && proto !== null) {
    return value;
  }

  if (Array.isArray(value)) {
    return value
      .map((item) => sanitizeForFirestore(item))
      .filter((item) => item !== undefined);
  }

  const result = {};
  for (const [key, val] of Object.entries(value)) {
    const sanitized = sanitizeForFirestore(val);
    if (sanitized !== undefined) {
      result[key] = sanitized;
    }
  }
  return result;
};
